import { render, staticRenderFns } from "./FormCambioPassword.vue?vue&type=template&id=4c64455b&scoped=true"
import script from "./FormCambioPassword.vue?vue&type=script&lang=js"
export * from "./FormCambioPassword.vue?vue&type=script&lang=js"
import style0 from "./FormCambioPassword.vue?vue&type=style&index=0&id=4c64455b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c64455b",
  null
  
)

export default component.exports